module.exports = __webpack_public_path__ + "Logo1-edad53da11b5622136219ecd44a05249.png";